import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("click", this.handleDocumentClick)
    document.addEventListener("keydown", this.handleKeydown)
    this._copyResetTimer = null
  }

  disconnect() {
    document.removeEventListener("click", this.handleDocumentClick)
    document.removeEventListener("keydown", this.handleKeydown)
    if (this._copyResetTimer) clearTimeout(this._copyResetTimer)
  }

  handleDocumentClick(event) {
    if (!this.hasMenuTarget || !this.menuTarget.open) return
    if (this.element.contains(event.target)) return
    this.menuTarget.open = false
  }

  handleKeydown(event) {
    if (event.key !== "Escape") return
    if (!this.hasMenuTarget || !this.menuTarget.open) return
    this.menuTarget.open = false
  }

  async copyEmail(event) {
    // mailto: link action is handled by the browser (no preventDefault)
    const link = event.currentTarget
    const email = link.dataset.email
    if (!email) return

    try {
      await navigator.clipboard.writeText(email)
    } catch {
      // Fallback for WebView / older browsers
      const textarea = document.createElement("textarea")
      textarea.value = email
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    }

    this._showCopiedFeedback(link)
  }

  _showCopiedFeedback(button) {
    if (this._copyResetTimer) clearTimeout(this._copyResetTimer)

    const label = button.querySelector("[data-role='email-label']")
    const icon = button.querySelector("[data-role='email-icon']")
    if (!label || !icon) return

    const originalLabel = label.textContent
    const originalIconHTML = icon.innerHTML

    label.textContent = button.dataset.copiedText || "Copied!"
    icon.innerHTML = '<path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>'
    icon.style.color = "var(--color-crust-600)"

    this._copyResetTimer = setTimeout(() => {
      label.textContent = originalLabel
      icon.innerHTML = originalIconHTML
      icon.style.color = ""
    }, 2000)
  }
}
